import request from '@/utils/request'

// 新增用户行为记录
export function addRecord(data) {
  return request({
    url: '/record/info',
    method: 'post',
    data: data
  })
}